import axios from '@/libraries/axios/main';
import EventManager from '@/services/EventManager';
import * as swal from 'sweetalert2';

// @ts-ignore
window.axios = axios;
// @ts-ignore
window.EventManager = new EventManager();
window.Swal = swal;
